// src/components/Service.js
import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Pune to Mumbai Cab 🚖",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/keyword/1.jpg",
    link: "/pune-to-mumbai-cab"
  },
  {
  id: 12,
  name: "Mumbai to Pune Daily Cab 🚗",
  desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
  image: "/images/keyword/42.jpg",
  link: "/mumbai-to-pune-daily-cab"
},
  {
    id: 2,
    name: "Airport Cab Service ✈️",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/keyword/87.jpg",
    // link: "/airport-cab-service"
  },
  {
    id: 3,
    name: "Outstation Cab Service 🛣️",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/3.jpg",
    // link: "/outstation-cab-service"
  },
  {
    id: 4,
    name: "Local City Rides 🏙️",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/4.jpg",
    // link: "/local-city-rides"
  },
  {
    id: 5,
    name: "Corporate Cab Service 🏢",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/5.jpg",
    // link: "/corporate-cab-service"
  },
  {
    id: 6,
    name: "One-Way Drop Service ➡️",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/6.jpg",
    // link: "/one-way-drop-service"
  },
  {
    id: 7,
    name: "Round Trip Taxi Service 🔁",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/7.jpg",
    // link: "/round-trip-taxi-service"
  },
  {
    id: 8,
    name: "Wedding & Event Transportation 💍",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/8.jpg",
    // link: "/wedding-event-transportation"
  },
  {
    id: 9,
    name: "Luxury Car Rental Service 🚘",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/9.jpg",
    // link: "/luxury-car-rental-service"
  },
  {
    id: 10,
    name: "Business Travel Cab Service 💼",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/10.jpg",
    // link: "/business-travel-cab-service"
  },
  {
    id: 11,
    name: "Festival & Event Special Rides 🎉",
    desc: "Enjoy a safe and comfortable ride with Velocity Cab. On-time service guaranteed.",
    image: "/images/service/11.jpg",
    // link: "/festival-event-special-rides"
  }
];

const Service = () => {
  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Services</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
        <div className="container">
          <div className="section-content">
            <div className="twm-cars-section m-b30">
              <div className="row">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.id}
                    className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                    data-wow-delay="0.2s"
                  >
                    <div className="twm-vehicle-fleet-bx twm-custom-grid-3 ">
                      <div className="twm-media twmtitle">
                        <div className="twm-media-pi borderrr twmtitle text-center">
                          <img src={vehicle.image} alt={vehicle.name} />
                        </div>
                      </div>
                      <div className="twm-vehicle-fleet-content ">
                        <h3 className="twm-v-title twmtitle twmtitle text-center">
                          <a className="twmtitle text-center" >{vehicle.name}</a>
                        </h3>
                        <ul className="twm-vehicle-facility">
                          <li>{vehicle.desc}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;